import Copy from "components/copy";
import { faRefresh } from "components/icon-library";
import Indicator from "components/indicator";
import { ColumnInterface } from "components/tables/interfaces";
import Table from "components/tables/table";
import { AWSEmailConfigurationStatus } from "models/email-domain-validation";
import { Fragment, FunctionComponent } from "react";

interface StatusTableProps {
  domain: string;
  status: AWSEmailConfigurationStatus;
  onCheck: () => Promise<void>;
}

interface Row {
  type: string;
  name: string;
  value: string;
  verified: boolean;
}

const StatusTable: FunctionComponent<StatusTableProps> = ({
  domain,
  status,
  onCheck,
}) => {
  const { dkim = [], dmarc } = status;

  const columns: ColumnInterface[] = [
    {
      key: "type",
      header: "Tietue",
      render: (row: Row) => row.type,
      width: 100,
    },
    {
      key: "name",
      header: "Nimi",
      render: (row: Row) => (
        <Fragment>
          {row.name}
          <Copy value={row.name} />
        </Fragment>
      ),
    },
    {
      key: "value",
      header: "Arvo",
      render: (row: Row) => (
        <Fragment>
          {row.value}
          <Copy value={row.value} />
        </Fragment>
      ),
    },
    {
      key: "status",
      header: "Tila",
      render: (row: Row) => (
        <Indicator type={row.verified ? "positive" : "negative"}>
          {row.verified ? "Kunnossa" : "Puuttuu"}
        </Indicator>
      ),
      width: 140,
    },
  ];

  const data: Row[] = [];
  dkim.forEach((entry) => {
    const { token, verified } = entry;
    data.push({
      type: "CNAME",
      name: `${token}._domainkey.${domain}`,
      value: `${token}.dkim.amazonses.com`,
      verified,
    });
  });

  data.push({
    type: "TXT",
    name: `${dmarc.token}.${domain}`,
    value: `v=DMARC1;p=none;rua=mailto:dmarc@${domain}`,
    verified: dmarc.verified,
  });

  return (
    <Table
      name="email-configuration"
      columns={columns}
      data={data}
      adder={{
        text: "Päivitä",
        icon: faRefresh,
        onClick: onCheck,
        isDisabled: () => true,
      }}
    />
  );
};

export default StatusTable;
